import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { twMerge } from "tailwind-merge";

interface ButtonProps {
    children: React.ReactNode;
    disabled?: boolean;
    className?: string;
    spinner?: boolean;
    /** Hover text, used to say why the button is disabled. */
    title?: string;
    onClick?: () => void;
}

export const Button = ({ children, disabled, spinner, className, title, onClick }: ButtonProps) => {
    return <button
        disabled={disabled}
        title={title}
        className={twMerge(
            "flex items-center justify-center gap-4 p-4 font-bold bg-gradient-to-r enabled:from-[#03CEFF] enabled:to-[#C91FFF] rounded hover:enabled:outline",
            'disabled:opacity-20 disabled:cursor-not-allowed',
            className
        )}
        onClick={() => onClick?.()}
    >{children}{spinner && <FontAwesomeIcon icon={faSpinner} spin />}</button>
}